<template>
    <v-server-table
        :url="route('trajectory-projects.trajectories.assignable.table', {
            trajectory_project: project,
        })"
        :columns="columns"
        :options="options"
        class="trigger"
        ref="table"
    >
        <template slot="candidate_name" slot-scope="{ row }" width="50">
            <router-link :to="{ name: 'admin.relations.trajectory-enrolments.edit', params: { relationId: row.relation_id, id: row.id }}">{{ row.relation.full_name }}</router-link>
        </template>
        <template slot="trajectory_name" slot-scope="{ row }" width="50">
            <router-link :to="{ name: 'admin.trajectory_projects.trajectories.view', params: { projectId: row.trajectory.trajectory_project_id, id: row.trajectory_id }}">{{ row.trajectory.name }}</router-link>
        </template>
    </v-server-table>
</template>

<script>
    import { TableMixin } from '~/mixins'

    export default {
        name: 'index',
        mixins: [ TableMixin ],
        props: {
            project: {
                required: true,
            },
        },

        data () {
            return {
                columns: [
                    'candidate_name',
                    'trajectory_name',
                ],
                filterable: [
                    'candidate_name',
                    'trajectory_name',
                ],
                options: {
                    headings: {
                        candidate_name: this.uLang('app.candidate_name'),
                        trajectory_name: this.uLang('app.trajectory_name'),
                    },
                    columnsClasses: {
                        'candidate_name': 'w50-column',
                        'trajectory_name': 'w50-column',
                    }
                },
            }
        },
    }
</script>

<style lang="css">
    td.w50-column {
        width: 50%;
    }
    table.VueTables__table td.w50-column {
        text-align: left;
    }
</style>
